module.exports = __webpack_public_path__ + "static/img/msg-image-2.3f7aa71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpn/msg-image-2.png
// module id = 26hd
// module chunks = 1